<template>
  <div class="flex grow items-center space-x-4" data-cy="platformInfo">
    <div
      v-if="!loggedInUser"
      data-cy="partner-logo"
      class="flex h-12 min-h-12 w-12 min-w-12 items-center justify-center overflow-hidden rounded-full border border-3 border-gray-300 bg-branding-icon"
    >
      <img
        v-if="branding?.logo"
        class="h-full w-full object-contain"
        :src="branding.logo.file_url"
        alt="logo"
        data-cy="partner-logo"
      />

      <icon-lendflow v-else data-cy="defaultLogo" />
    </div>
    <loading-skeleton v-if="showLoadingFullscreen" class="w-full rounded-md" :speed="2">
      <div class="h-8 w-full bg-branding-background" data-cy="platform-info-loader"></div>
    </loading-skeleton>
    <div v-else class="font-medium">
      <template v-if="authToken && loggedInUser">
        <div v-if="allApplications.length && selectedApplication?.id">
          <div class="flex flex-col space-y-1">
            <application-dropdown data-cy="applicationDropdown" />
            <span class="text-sm text-white/70">
              {{ applicationDate }}
            </span>
          </div>
        </div>
        <span v-else class="text-xl" data-cy="appTitle">
          {{ $t("common.title") }}
        </span>
      </template>
      <span v-else class="text-xl text-branding-heading" data-cy="loginTitle">
        {{ $t("auth.title") }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { formatDate } from "@/util/formatting";
import useBrandingState from "@/composables/state/brandingState";
import IconLendflow from "@/components/icons/IconLendflow.vue";
import LoadingSkeleton from "@/components/loading/LoadingSkeleton.vue";
import usePlatformScreenState from "@/composables/state/platformScreenState";
import useAuthState from "@/composables/state/authState";
import useApplicationsState from "@/composables/state/applicationsState";
import ApplicationDropdown from "@/components/platform/PlatformApplicationDropdown.vue";

const { showLoadingFullscreen } = usePlatformScreenState();
const { authToken, loggedInUser } = useAuthState();
const { selectedApplication, allApplications } = useApplicationsState();
const { branding } = useBrandingState();

const applicationDate = computed(() => formatDate(selectedApplication.value?.created_at ?? ""));
</script>
